export class FilterService {
  pPromise: Promise<void> = Promise.resolve();
  isPromiseSet: boolean = false;
  disarmCb: () => void = null;

  get promise() {
    if (this.pPromise) {
      return this.pPromise;
    }

    return Promise.resolve();
  }

  get isSet() {
    return this.isPromiseSet;
  }

  clear() {
    this.isPromiseSet = false;
  }

  set() {
    this.isPromiseSet = true;
    this.pPromise = new Promise((resolve) => {
      this.disarmCb = () => {
        resolve();
      };
    });
  }

  disarm() {
    if (this.disarmCb) {
      this.disarmCb();
    }
  }
}

export default new FilterService();
